export default __webpack_public_path__ + "static/media/lilian3.0942c45d.jpg";